import {SELECT_INTENT} from 'src/pages/scheduleCallback/constants/views';
import {
  setEmail,
  setIntent,
  setPhone,
} from 'src/pages/scheduleCallback/store/actions/app';
import {cancelAppointmentStep} from 'src/pages/scheduleCallback/store/actions/cancelAppointmentStep';
import {selectTimeslotStep} from 'src/pages/scheduleCallback/store/actions/selectTimeslotStep';
import {
  email,
  hasAppointment,
  intent,
  phone,
  shouldShowIntents,
} from 'src/pages/scheduleCallback/store/selectors/app';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {pushHistory} from 'src/shared/history/actions';

export const selectIntentStep = () => (dispatch, getState) => {
  if (hasAppointment(getState())) {
    return dispatch(cancelAppointmentStep());
  }
  if (!shouldShowIntents(getState())) {
    return dispatch(selectTimeslotStep());
  }
  dispatch(pushHistory(selectIntentStep(), fragment('contact')));
  dispatch(setPhone(phone(getState())));
  dispatch(setEmail(email(getState())));
  dispatch(setIntent(intent(getState())));
  dispatch(changeView(SELECT_INTENT));
  logScreenName('selectintent');
};
